import { render, staticRenderFns } from "./selectionExpandable.vue?vue&type=template&id=1a4489fb&"
import script from "./selectionExpandable.vue?vue&type=script&lang=js&"
export * from "./selectionExpandable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports